/* CUBE × ProVelo — vocabular comun de mișcare + cumpărare.
   Se încarcă (defer) din orice secțiune cube-*.liquid; e idempotent (o singură inițializare pe pagină).
   - .cube-reveal / .cube-stagger / .cube-zoom  → apar la intrarea în viewport (IntersectionObserver)
   - [data-cube-parallax="0.12"]                → deplasare lentă pe scroll (doar desktop, fără reduced-motion)
   - .cube-acc__btn                             → acordeon animat (grid-template-rows)
   - [data-cube-count]                          → numerele mari cresc o dată, când devin vizibile
   - form[data-cube-form]                       → add-to-cart prin /cart/add.js + sertarul temei Sleek (cart-drawer.onCartRefresh)
   - [data-cube-size]                           → selectorul de mărime; sincronizează hero + bara sticky + input[name=id]
   - .cube-sticky                               → apare când butonul principal din hero iese din ecran
*/
(function () {
  if (window.__cubeSys) return;
  window.__cubeSys = true;

  var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function ready(fn) { if (document.readyState !== 'loading') fn(); else document.addEventListener('DOMContentLoaded', fn); }

  /* ---------- 1. reveal ---------- */
  function initReveal() {
    var els = document.querySelectorAll('.cube-reveal, .cube-stagger, .cube-zoom');
    if (!els.length) return;
    if (reduced || !('IntersectionObserver' in window)) { els.forEach(function (e) { e.classList.add('is-in'); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
    els.forEach(function (e) { io.observe(e); });
  }

  /* ---------- 2. parallax (ușor, doar unde are sens) ---------- */
  function initParallax() {
    var els = [].slice.call(document.querySelectorAll('[data-cube-parallax]'));
    if (!els.length || reduced || window.innerWidth < 900) return;
    var ticking = false;
    function frame() {
      var vh = window.innerHeight;
      els.forEach(function (el) {
        var r = el.getBoundingClientRect();
        if (r.bottom < 0 || r.top > vh) return;
        var amt = parseFloat(el.getAttribute('data-cube-parallax')) || 0.1;
        var p = (r.top + r.height / 2 - vh / 2) / vh;      // -0.5 .. 0.5
        el.style.transform = 'translate3d(0,' + (-p * amt * 100).toFixed(2) + 'px,0)';
      });
      ticking = false;
    }
    function onScroll() { if (!ticking) { ticking = true; requestAnimationFrame(frame); } }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    frame();
  }

  /* ---------- 3. acordeon ---------- */
  function initAccordion() {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest && e.target.closest('.cube-acc__btn');
      if (!btn) return;
      var item = btn.closest('.cube-acc__item');
      var open = item.classList.toggle('is-open');
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      var acc = item.closest('.cube-acc');
      if (acc && acc.hasAttribute('data-single') && open) {
        acc.querySelectorAll('.cube-acc__item.is-open').forEach(function (o) {
          if (o !== item) { o.classList.remove('is-open'); var b = o.querySelector('.cube-acc__btn'); if (b) b.setAttribute('aria-expanded', 'false'); }
        });
      }
    });
  }

  /* ---------- 4. numere care cresc ---------- */
  function initCount() {
    var els = document.querySelectorAll('[data-cube-count]');
    if (!els.length) return;
    function run(el) {
      var target = parseFloat(el.getAttribute('data-cube-count')); var dec = parseInt(el.getAttribute('data-cube-dec') || '0', 10);
      var suf = el.getAttribute('data-cube-suffix') || ''; var pre = el.getAttribute('data-cube-prefix') || '';
      if (reduced) { el.textContent = pre + target.toFixed(dec).replace('.', ',') + suf; return; }
      var t0 = null, dur = 1400;
      function step(ts) {
        if (!t0) t0 = ts; var k = Math.min(1, (ts - t0) / dur); var e = 1 - Math.pow(1 - k, 3);
        el.textContent = pre + (target * e).toFixed(dec).replace('.', ',') + suf;
        if (k < 1) requestAnimationFrame(step);
      }
      requestAnimationFrame(step);
    }
    if (!('IntersectionObserver' in window)) { els.forEach(run); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { run(en.target); io.unobserve(en.target); } });
    }, { threshold: 0.4 });
    els.forEach(function (e) { io.observe(e); });
  }

  /* ---------- 5. mărime + cumpărare ---------- */
  function money(cents) {
    var v = Math.round(cents) / 100;
    var s = v.toLocaleString('ro-RO', { minimumFractionDigits: 0, maximumFractionDigits: 0 });
    return s + ' lei';
  }
  function initBuy() {
    var form = document.querySelector('form[data-cube-form]');
    if (!form) return;
    var idInput = form.querySelector('input[name="id"]');
    var variants = [];
    try {
      var src = form.querySelector('[data-cube-variants]') || document.querySelector('[data-cube-variants]');
      variants = JSON.parse((src && (src.textContent || src.getAttribute('data-cube-variants'))) || '[]');
    } catch (e) { variants = []; }
    var sizeBtns = [].slice.call(document.querySelectorAll('[data-cube-size]'));
    var priceEls = [].slice.call(document.querySelectorAll('[data-cube-price]'));
    var wasEls = [].slice.call(document.querySelectorAll('[data-cube-was]'));
    var stockEls = [].slice.call(document.querySelectorAll('[data-cube-stock]'));
    var wheelEls = [].slice.call(document.querySelectorAll('[data-cube-wheel]'));
    var btns = [].slice.call(document.querySelectorAll('[data-cube-atc]'));

    function variantById(id) { for (var i = 0; i < variants.length; i++) if (String(variants[i].id) === String(id)) return variants[i]; return null; }
    function select(id, silent) {
      var v = variantById(id); if (!v) return;
      if (idInput) idInput.value = v.id;
      sizeBtns.forEach(function (b) { b.classList.toggle('is-active', String(b.getAttribute('data-cube-size')) === String(v.id)); });
      priceEls.forEach(function (e) { e.textContent = money(v.price); });
      wasEls.forEach(function (e) { if (v.compare_at_price && v.compare_at_price > v.price) { e.textContent = money(v.compare_at_price); e.hidden = false; } else { e.hidden = true; } });
      stockEls.forEach(function (e) {
        var txt = v.available ? (v.inventory_quantity > 0 ? e.getAttribute('data-txt-stock') : e.getAttribute('data-txt-order')) : e.getAttribute('data-txt-soldout');
        if (txt) e.textContent = txt;
        e.classList.toggle('cube-stock--order', !(v.inventory_quantity > 0));
      });
      wheelEls.forEach(function (e) { var w = e.getAttribute('data-wheel-' + v.title.toLowerCase().replace(/[^a-z0-9]/g, '')); if (w) e.textContent = w; });
      btns.forEach(function (b) { b.classList.toggle('is-disabled', !v.available); });
      try { document.dispatchEvent(new CustomEvent('cube:variant', { detail: v })); } catch (e) {}
      if (!silent && history.replaceState) {
        var u = new URL(window.location.href); u.searchParams.set('variant', v.id); history.replaceState(null, '', u.toString());
      }
    }
    sizeBtns.forEach(function (b) {
      b.addEventListener('click', function (ev) { ev.preventDefault(); select(b.getAttribute('data-cube-size')); });
    });
    // starea inițială
    var initial = (idInput && idInput.value) || (variants[0] && variants[0].id);
    var uv = new URL(window.location.href).searchParams.get('variant');
    if (uv && variantById(uv)) initial = uv;
    if (initial) select(initial, true);

    // add to cart → sertarul temei
    var busy = false;
    function addToCart() {
      if (busy) return; busy = true;
      btns.forEach(function (b) { b.classList.add('is-busy'); b.setAttribute('aria-busy', 'true'); });
      var fd = new FormData(form);
      fetch('/cart/add.js', { method: 'POST', headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: fd })
        .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
        .then(function (res) {
          if (!res.ok) { alert(res.j && res.j.description ? res.j.description : 'Nu am putut adăuga produsul în coș.'); return; }
          var drawer = document.querySelector('cart-drawer');
          if (drawer && typeof drawer.onCartRefresh === 'function') { drawer.onCartRefresh({ detail: { open: true } }); }
          else { window.location.href = '/cart'; }
        })
        .catch(function () { window.location.href = '/cart'; })
        .then(function () { busy = false; btns.forEach(function (b) { b.classList.remove('is-busy'); b.removeAttribute('aria-busy'); }); });
    }
    form.addEventListener('submit', function (e) { e.preventDefault(); addToCart(); });
    btns.forEach(function (b) { if (b.tagName !== 'BUTTON' || b.getAttribute('form') !== form.id) b.addEventListener('click', function (e) { e.preventDefault(); addToCart(); }); });

    // bara sticky
    var sticky = document.querySelector('.cube-sticky');
    var anchor = document.querySelector('[data-cube-hero-cta]');
    if (sticky && anchor && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) { sticky.classList.toggle('is-visible', !en.isIntersecting && en.boundingClientRect.top < 0); });
      }, { threshold: 0 });
      io.observe(anchor);
    }
  }

  /* ---------- 6. ancore interne (Sleek interceptează uneori href="#…") ---------- */
  function initScroll() {
    document.addEventListener('click', function (e) {
      var a = e.target.closest && e.target.closest('.cube a[href^="#"], a[data-cube-scroll]');
      if (!a) return;
      var id = (a.getAttribute('href') || '').replace(/^#/, ''); if (!id) return;
      var t = document.getElementById(id); if (!t) return;
      e.preventDefault();
      var header = document.querySelector('.header-sticky, header.header, .shopify-section-group-header-group');
      var off = header ? Math.min(140, header.getBoundingClientRect().height) : 80;
      var y = t.getBoundingClientRect().top + window.pageYOffset - off - 12;
      window.scrollTo({ top: Math.max(0, y), behavior: reduced ? 'auto' : 'smooth' });
      if (history.replaceState) history.replaceState(null, '', '#' + id);
    });
  }

  ready(function () { initReveal(); initParallax(); initAccordion(); initCount(); initBuy(); initScroll(); });
})();
